import { render, staticRenderFns } from "./LandingFooter.vue?vue&type=template&id=c108c2b4&scoped=true"
import script from "./LandingFooter.vue?vue&type=script&lang=js"
export * from "./LandingFooter.vue?vue&type=script&lang=js"
import style0 from "./LandingFooter.vue?vue&type=style&index=0&id=c108c2b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c108c2b4",
  null
  
)

export default component.exports